import type { ReactNode, FunctionComponent } from "react";
import { useRef } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import type { ITooltip } from "react-tooltip";
import styled from "styled-components";
import { QuestionIcon } from "./QuestionIcon";

const TooltipWrapper = styled.div`
	position: relative;
	display: inline-flex;
	cursor: pointer;
`;

const StyledTooltip = styled(ReactTooltip)`
	&.react-tooltip {
		background: var(--surface-container-highest);
		color: var(--text-title);
		padding: 0.5rem 0.75rem;
		border-radius: 0.375rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		max-width: 300px;
		white-space: pre-wrap;
		word-break: break-word;
		opacity: 1;
	}
`;

type TooltipProps = {
	message: ReactNode;
	children?: ReactNode;
	position?: ITooltip["place"];
};

export const Tooltip: FunctionComponent<TooltipProps> = ({
	message,
	position = "bottom",
	children,
}) => {
	const tooltipId = useRef(`tooltip-${Math.random().toString(36).slice(2, 9)}`);

	return (
		<>
			<TooltipWrapper data-tooltip-id={tooltipId.current}>
				{children || <QuestionIcon />}
			</TooltipWrapper>
			<StyledTooltip
				id={tooltipId.current}
				place={position}
				render={() => message}
			/>
		</>
	);
};
